import { PositionDateField } from "../../enums";

export const ActionTypes = {
    SET_SWAPS: "SET_SWAPS",
    SET_CENTERLIST: "SET_CENTERLIST",
    SET_CHAINSTATUSLIST: "SET_CHAINSTATUSLIST",
    SET_CLUSTERSTATUSLIST: "SET_CLUSTERSTATUSLIST",
    SET_LOGISTICSPROVIDERS: "SET_LOGISTICSPROVIDERS",
    SET_PAIRSTATUSLIST: "SET_PAIRSTATUSLIST",
    SET_STAFFLIST: "SET_STAFF",
    SET_TRANSPORTTYPELIST: "SET_TRANSPORTTYPELIST",
    SET_SWAPTYPELIST: "SET_SWAPTYPELIST",
    SET_DISTANCE_BETWEEN_CENTERS: 'SET_DISTANCE_BETWEEN_CENTERS',
    SET_RCCAPPHASELIST: "SET_RCCAPPHASELIST",
    SET_RCCAPAVOIDABLELIST: "SET_RCCAPAVOIDABLELIST",
    SET_RCCAPBILLABLELIST: "SET_RCCAPBILLABLELIST",
    SET_RCCAPCAUSELIST: "SET_RCCAPCAUSELIST",
    SET_RCCAPCORRECTIVEACTIONLIST: "SET_RCCAPCORRECTIVEACTIONLIST",
    SET_RCCAPSATISFACTORYRESPONSELIST: "SET_RCCAPSATISFACTORYRESPONSELIST",
    SET_SWAP_FOR_COURIER: "SET_SWAP_FOR_COURIER",

    UPDATE_KIDNEYPICKUP_DATETIME: "UPDATE_KIDNEYPICKUP_DATETIME",
    UPDATE_KIDNEYARRIVAL_DATETIME: "UPDATE_KIDNEYARRIVAL_DATETIME",
    UPDATE_SWAP_MANAGER: "UPDATE_SWAP_MANAGER",
    UPDATE_LOGISTICS_PROVIDER: "UPDATE_LOGISTICS_PROVIDER",
    UPDATE_CHAIN_MATCHOFFER_DEADLINE_DATETIME: "UPDATE_CHAIN_MATCHOFFER_DEADLINE_DATETIME",
    UPDATE_MATCHOFFER_DEADLINE_DATETIME: "UPDATE_MATCHHISTORY_DEADLINE_DATETIME",
    UPDATE_CROSSMATCH_DEADLINE_DATETIME: "UPDATE_CROSSMATCH_DEADLINE_DATETIME",
    UPDATE_KICKOFF_DATETIME: "UPDATE_KICKOFF_DATETIME",
    UPDATE_LOGISTICS_DATETIME: "UPDATE_LOGISTICS_DATETIME",
    UPDATE_PAIR_STATUS: "UPDATE_PAIR_STATUS",
    UPDATE_LOGISTICS: "UPDATE_LOGISTICS",
    UPDATE_COMMENT: "UPDATE_COMMENT",
    UPDATE_GPS: "UPDATE_GPS",
    UPDATE_SWAP_FOR_LOGISTICS_OPTION: "UPDATE_SWAP_FOR_LOGISTICS_OPTION",
    UPDATE_SWAP_FOR_LOGISTICS_OPTION_DELETE_RETURN: 'UPDATE_SWAP_FOR_LOGISTICS_OPTION_DELETE_RETURN',
    UPDATE_MATCHING_SURGERIES: 'UPDATE_MATCHING_SURGERIES'
};

export const DateFieldMap = {
    [ActionTypes.UPDATE_KIDNEYPICKUP_DATETIME]: PositionDateField.KidneyPickupDateTime,
    [ActionTypes.UPDATE_KIDNEYARRIVAL_DATETIME]: PositionDateField.KidneyArrivalDateTime,
    [ActionTypes.UPDATE_MATCHOFFER_DEADLINE_DATETIME]: PositionDateField.MatchOfferDeadlineDateTime,
    [ActionTypes.UPDATE_CROSSMATCH_DEADLINE_DATETIME]: PositionDateField.CrossMatchDeadlineDateTime
};